export const ownerInfo = {
  caption: "Информация о собственнике",
  keyTable: "ownerTableColumns",
  gridKey: "grid-container-owner",
  blockVisibility: true,
  inputsOptions: {
    boatName: {
      key: "boatName",
      label: "Название (при наличии)",
      fieldModeView: true,
      needInForm: true,
    },
    fio: {
      key: "fio",
      label: "Собственник (ФИО либо наименование юридического лица)",
      fieldModeView: true,
      needInForm: true,
    },
    address: {
      key: "address",
      label: "Адрес",
      fieldModeView: true,
      needInForm: true,
    },
    persNum: {
      key: "persNum",
      label: "Идентификационный номер",
      fieldModeView: true,
      needInForm: true,
    },
    note2: {
      key: "note2",
      label: "Арендатор, лизингополучатель (ФИО либо наименование юридического лица)",
      fieldModeView: true,
      needInForm: true,
    },
  },
};

export const boatInfo = {
  caption: "Корпус",
  keyTable: "boatTableColumns",
  gridKey: "grid-container-boat-info",
  blockVisibility: true,
  inputsOptions: {
    boatTypeVid: {
      key: "boatTypeVid",
      label: "Тип, вид",
      fieldModeView: true,
      needInForm: true,
    },
    boatVin: {
      key: "boatVin",
      label: "Заводской  (идентификационный) номер",
      fieldModeView: true,
      needInForm: true,
    },
    boatYear: {
      key: "boatYear",
      label: "Год постройки",
      fieldModeView: true,
      needInForm: true,
    },
    bodyMaterial: {
      key: "bodyMaterial",
      label: "Материал",
      fieldModeView: true,
      needInForm: true,
    },
    boatLength: {
      key: "boatLength",
      label: "Длина, м",
      fieldModeView: true,
      needInForm: true,
    },
    boatWidth: {
      key: "boatWidth",
      label: "Ширина, м",
      fieldModeView: true,
      needInForm: true,
    },
    boatHeight: {
      key: "boatHeight",
      label: "Высота борта, м",
      fieldModeView: true,
      needInForm: true,
    },
    boatPayload: {
      key: "boatPayload",
      label: "Грузоподъемность,кг",
      fieldModeView: true,
      needInForm: true,
    },
    passengersNum: {
      key: "passengersNum",
      label: "Допустимое количество людей на борту, чел",
      fieldModeView: true,
      needInForm: true,
    },
    engpwrmax: {
      key: "engpwrmax",
      label: "Предельная мощность двигателей , л.с.",
      fieldModeView: true,
      needInForm: true,
    },
    saCategory: {
      key: "saCategory",
      label: "Категория сложности района плавания",
      fieldModeView: true,
      needInForm: true,
    },
  },
};
